// @flow
import { map, values, pipe, sort, ascend, addIndex, prop } from 'ramda';

import type { Params, ComplexMap } from 'app/common/components/Cafeteria/dataTypes/order/Complex.types';

import type { Request } from '../../../../index';


const dateFormatApi = 'YYYY-MM-DD';

const mapIndexed = addIndex(map);

type ApiParams = {
  customer_id: number | string,
  order_id: number | string,
  date: string,
}

export const convertParams = ({ date, customerId, orderRequestId }: Params): [ApiParams, null] => {
  return [{
    customer_id: customerId,
    order_id: orderRequestId,
    date: date.getString(dateFormatApi),
  }, null];
};

type ResultApi = {
  [guid: string]: {
    guid: string,
    title: ?string,
    cost: ?number,
    items: Array<{
      title: string,
      portion: ?string,
      cost: ?number,
    }>,
  },
}

const sortByTitle = sort(ascend(prop('title')));

export const convertResult = (dataApi: ResultApi): ComplexMap => {
  return new Map(pipe(
    values,
    sortByTitle,
    map(({ guid, title, items, cost }) => ([guid, {
      id: guid,
      title: title || '???',
      cost: cost !== null && cost !== undefined ? cost : null,
      freeCount: 0,
      dishes: pipe(
        sortByTitle,
        // $FlowFixMe
        mapIndexed(({ title: t, portion }, index) => ({
          title: t || '???',
          index,
          portion: portion || '',
        })),
      )(items || []),
    }])),
  )(dataApi));
};

export const GET_CAFETERIA_CUSTOMER_COMPLEXES: Request<
  Params,
  ComplexMap,
  void
> = [
  'cafeteria/customer/orders/complexes',
  'get',
  ['data', 'complexes'],
];
